import { Directive, ElementRef } from '@angular/core';
import { DesktopService } from '../providers/desktop-service';

@Directive({
    selector: '[mobile-only]'
})
export class MobileOnlyDirective {
    public isDesktop: boolean = false;
    public element: HTMLElement = null;

    constructor(
        private desktop: DesktopService,
        private elementRef: ElementRef,
    ) {
        this.isDesktop = desktop.isDesktop();
    }

    public ngOnInit() {
        this.element = this.elementRef.nativeElement;
        if (this.isDesktop) this.element.classList.add('hidden');
    }
}



// WEBPACK FOOTER //
// ./src/directives/mobile-only.ts